import { CheckIcon } from "@chakra-ui/icons";
import { Box, List, ListIcon, ListItem } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import {
  BACKGROUND_COLOR_DARK,
  BACKGROUND_COLOR_LIGHT,
  userDetailsTab,
} from "../../constants";
const UserDetailsTab = () => {
  const { currentTimelineStep } = useSelector((store) => store.userDetails);
  return (
    <Box
      boxShadow={
        "rgba(17, 17, 26, 0.05) 0px 0px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;"
      }
      className=" h-full rounded-2xl"
      backgroundColor={"white"}
    >
      <List
        spacing={0}
        className="py-6 flex flex-col gap-y-4 text-[#595657] text-lg "
      >
        {userDetailsTab.map((tabName, index) => (
          <ListItem
            key={"usertab " + tabName}
            className={
              "px-5 mx-3 py-2 rounded-xl " +
              (currentTimelineStep === index + 1 && "font-[700]")
            }
            style={{
              color:
                currentTimelineStep === index + 1 ? BACKGROUND_COLOR_DARK : "",
              backgroundColor:
                currentTimelineStep === index + 1 ? BACKGROUND_COLOR_LIGHT : "",
            }}
            fontSize={"16px"}
          >
            {index + 1 < currentTimelineStep && (
              <ListIcon as={CheckIcon} mr={4} color="green.500" />
            )}
            {tabName}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default UserDetailsTab;
